<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title>
                <v-icon large left>mdi-factory</v-icon>
                <span class="title font-weight-light">Organização</span>
                <v-spacer/>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="RelatorioUltimoAcesso()">
                            <v-icon>mdi-clock</v-icon>
                        </v-btn>
                    </template>
                    <span>Exportar Último Acesso</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="RelatorioPlanosPagos()">
                            <v-icon>mdi-cash</v-icon>
                        </v-btn>
                    </template>
                    <span>Exportar Planos Pagos</span>
                </v-tooltip>
    
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="ExportarExcel()">
                            <v-icon>mdi-file-excel</v-icon>
                        </v-btn>
                    </template>
                    <span>Exportar</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Atualizar()">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </template>
                    <span>Atualizar</span>
                </v-tooltip>

                <v-expansion-panels focusable>
                    <v-expansion-panel>
                        <v-expansion-panel-header>Filtros</v-expansion-panel-header>
                        <v-expansion-panel-content class="mt-5">
                            <v-row dense>
                                <v-col cols="12" sm="4">
                                    <v-text-field v-model="filtro.cpfCnpj" label="CPF/CNPJ" @input="filtro.cpfCnpj = FormatarCpfCnpj($event)" @blur="filtro.cpfCnpj = (filtro.cpfCnpj || '').toLocaleUpperCase()" outlined dense clearable/>
                                </v-col>
                                <v-col cols="12" sm="5">
                                    <v-text-field v-model="filtro.nome" label="Nome" outlined dense clearable/>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-autocomplete v-model="planoSelecionado" label="Plano" :items="planos" item-value="id" item-text="nome" return-object multiple outlined dense/>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-autocomplete v-model="filtro.situacao" label="Situação" :items="situacoes" item-value="id" item-text="nome" outlined dense/>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-autocomplete v-model="filtro.crm" label="CRM" :items="crms" item-value="id" item-text="nome" outlined dense/>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-text-field v-model="filtro.origem" label="Origem" outlined dense clearable/>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

            </v-card-title>
    
            <v-card-text>
    
                <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip right>
                            <template v-slot:activator="{ on }">
                            <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                            </template>
                            <span>Editar</span>
                        </v-tooltip>
                    </template>

                    <template v-slot:[`item.vencimentoBoleto`]="{ item }">
                        {{ item.vencimentoBoleto ? new Date(item.vencimentoBoleto).ddmmyyyy() : ""}}
                    </template>

                    <template v-slot:[`item.situacao`]="{ item }">
                        {{ item.situacao ? "ATIVO" : "INATIVO"}}
                    </template>

                    <template v-slot:[`item.crm`]="{ item }">
                        {{ item.crm ? "SIM" : "NÃO"}}
                    </template>
        
                </v-data-table>
            </v-card-text>
            
        </v-card>
        
        <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <cadastro-administrativo-empresa v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Atualizar()"/>
        
        </master-page>
</template>

<script>
import { FormatarCpfCnpj, MskCpf, MskCnpj, MskCnpjAlfa } from '@/core/domain/shared/Global';
import UsuarioService from '../../../core/services/geral/UsuarioService';
import { EmpresaService } from '../../../core/services/geral';
import { Empresa } from '../../../core/domain/geral';
import JSONToCSVConverter from '../../../assets/js/custom';
import AdministrativoService from '../../../core/services/AdministrativoService';

export default {
data() {
    return {
        service: new AdministrativoService(),
        item: new Empresa(),
        totalLista: 0,
        lista: [],
        dialogCadastro: false,
        loading: true,
        primeiraCarga: true,
        options: {
            itemsPerPage: 15
        },
        headers: [
            { text: '', value:'actions', sortable: false  },
            { text: 'Código', value: 'id', type: 'number', sortable: false},
            { text: 'Nome', value: 'nome', sortable: false},
            { text: 'Cpf/Cnpj', value: 'cpfCnpj', sortable: false},
            { text: 'Responsavel', value: 'responsavel', sortable: false},
            { text: 'Responsavel Telefone', value: 'responsavel_Tel', sortable: false},
            { text: 'Responsavel Email', value: 'responsavel_Email', sortable: false},
            { text: 'Vencimento Boleto', value: 'vencimentoBoleto', sortable: false},
            { text: 'Plano', value: 'planoStr', sortable: false},
            { text: 'CRM', value: 'crm', sortable: false},
            { text: 'Situação', value: 'situacao', sortable: false},
            { text: 'Origem', value: 'origem', sortable: false}
        ],
        filtro: {
            cpfCnpj: null,
            nome: null,
            plano: 'E, B, P, O',
            crm: null,
            situacao: true,
            origem: null
        },
        planoSelecionado: [],
        planos: [
            { id: 'G', nome: "Gratuito"},
            { id: 'E', nome: "Edital"},
            { id: 'B', nome: "Bronze"},
            { id: 'P', nome: "Prata"},
            { id: 'O', nome: "Ouro"}
        ],
        situacoes: [
            { id: null, nome: "TODOS"},
            { id: true, nome: "ATIVO"},
            { id: false, nome: "INATIVO"}
        ],
        crms: [
            { id: null, nome: "TODOS"},
            { id: true, nome: "SIM"},
            { id: false, nome: "NÃO"}
        ],
        mskCnpj: MskCnpj,
        mskCnpjAlfa: MskCnpjAlfa,
        maskCpf: MskCpf,
        mask: [MskCpf, MskCnpj, MskCnpjAlfa],
    }
},
watch: {
    options: {
        handler () {
            this.Atualizar();
        },
        deep: true
    },
    lista: function(){
        if(this.primeiraCarga)
            this.primeiraCarga = false;
    },
    "filtro.cpfCnpj": function(val){
        val = val || '';
        const upper = val.toLocaleUpperCase();
        if (upper !== val) {
            this.filtro.cpfCnpj = upper;
            return;
        }

        if(/[A-Z]/.test(val)){
            this.mask = this.mskCnpjAlfa;
            this.item.isJuridica = true;
        }
        else if(val.length > 14){
            this.mask = this.mskCnpj;
            this.item.isJuridica = true;
        }
        else{
            this.mask = this.maskCpf;
            this.item.isJuridica = false;
        }
    }
},
methods: {
    FormatarCpfCnpj,
    Atualizar(){
        this.loading = true;

        this.filtro.plano = "";

        this.planoSelecionado.forEach(plano => {
            this.filtro.plano += plano.id + ",";
        });
        
        const { page, itemsPerPage, sortBy, sortDesc, search, columns } = this.options;

        this.service.ListarEmpresas(page, itemsPerPage, this.filtro.cpfCnpj, this.filtro.nome, this.filtro.plano, this.filtro.situacao, this.filtro.crm, this.filtro.origem).then(
            res => {
                this.lista = res.data.items; 
                this.totalLista = res.data.count;
            },
            err => {
                this.$swal('Aviso', err.response.data, 'error');
            }
        ).finally(() => {
            this.loading = false;
        });
    },
    Editar(item){
        new EmpresaService().ObterPorId(item.id).then(
            res =>{
                this.item = Object.assign({}, new Empresa(res.data))
                this.dialogCadastro = true;
                this.baixa = false;
            },
            err => this.$swal('Aviso', err.response.data, 'error')
        )
    },
    VerificarSessao(){
        const authenticated = localStorage.getItem('administrativo')
        if(!(!!authenticated)){
            localStorage.clear();
            this.$router.push({ name: 'principal' });
        }
    },
    ExportarExcel(){
        this.service.ListarEmpresas(0, 0, this.filtro.cpfCnpj, this.filtro.nome, this.filtro.plano, this.filtro.situacao, this.filtro.crm, this.filtro.origem).then(
            res => {
                let listagem = res.data.items;
                JSONToCSVConverter(listagem, "Exportar Empresas");
            },
            err => {
                this.$swal('Aviso', err.response.data, 'error');
            }
        ).finally(() => {
            this.loading = false;
        });
    },
    RelatorioPlanosPagos(){
        this.service.RelatorioEmpresa().then(
            res => {
                let listagem = res.data;
                JSONToCSVConverter(listagem, "Relatorio Planos Pagos");
            },
            err => {
                this.$swal('Aviso', err.response.data, 'error');
            }
        ).finally(() => {
            this.loading = false;
        });
    },
    RelatorioUltimoAcesso(){
        this.service.RelatorioUltimoLogin().then(
            res => {
                let listagem = res.data;
                JSONToCSVConverter(listagem, "Relatorio Ultimo Acesso");
            },
            err => {
                this.$swal('Aviso', err.response.data, 'error');
            }
        ).finally(() => {
            this.loading = false;
        });
    }
},
created(){
    this.sessionApp = JSON.parse(localStorage.sessionApp);
    const usuarioService = new UsuarioService();
    usuarioService.ListarTudo("Permissoes").then(
        res=>{
            var usuario = res.data.items;
            usuario = usuario.find(x => x.id == this.sessionApp.usuarioId)
            this.permissoes = usuario.permissoes;
        }
    )
},
mounted() {
    this.VerificarSessao();
    this.filtro.plano.split(",").forEach(plano => {
        var _plano = this.planos.find(x => x.id == plano.trim());
        this.planoSelecionado.push(_plano);
    });
}
}
</script>
